<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <path class="cls-2" d="m37.28,40.8c1,0,1.84.84,1.84,1.84v29.95c0,1-.84,1.84-1.84,1.84h-15.09c-1,0-1.84-.84-1.84-1.84v-29.95c0-1,.84-1.84,1.84-1.84h15.09m0-3.41h-15.09c-2.89,0-5.25,2.36-5.25,5.25v29.95c0,2.89,2.36,5.25,5.25,5.25h15.09c2.89,0,5.25-2.36,5.25-5.25v-29.95c0-2.89-2.36-5.25-5.25-5.25h0Z"/>
  <path class="cls-3" d="m37.9,21.66c.67,0,1.23.56,1.23,1.23v5.9c0,.67-.56,1.23-1.23,1.23h-16.32c-.67,0-1.23-.56-1.23-1.23v-5.9c0-.67.56-1.23,1.23-1.23h16.32m0-3.41h-16.32c-2.55,0-4.63,2.09-4.63,4.63v5.9c0,2.55,2.09,4.63,4.63,4.63h16.32c2.55,0,4.63-2.09,4.63-4.63v-5.9c0-2.55-2.09-4.63-4.63-4.63h0Z"/>
  <path class="cls-4" d="m66.56,58.74h-14c-3.63,0-6.58-2.95-6.58-6.58v-27.58c0-3.63,2.95-6.58,6.58-6.58.94,0,1.7.76,1.7,1.7s-.76,1.7-1.7,1.7c-1.75,0-3.17,1.42-3.17,3.17v27.58c0,1.75,1.42,3.17,3.17,3.17h14c1.75,0,3.17-1.42,3.17-3.17v-27.58c0-1.75-1.42-3.17-3.17-3.17-.94,0-1.7-.76-1.7-1.7s.76-1.7,1.7-1.7c3.63,0,6.58,2.95,6.58,6.58v27.58c0,3.63-2.95,6.58-6.58,6.58Z"/>
  <path class="cls-3" d="m67.72,66.09c.67,0,1.23.56,1.23,1.23v5.9c0,.67-.56,1.23-1.23,1.23h-16.32c-.67,0-1.23-.56-1.23-1.23v-5.9c0-.67.56-1.23,1.23-1.23h16.32m0-3.41h-16.32c-2.55,0-4.63,2.09-4.63,4.63v5.9c0,2.55,2.09,4.63,4.63,4.63h16.32c2.55,0,4.63-2.09,4.63-4.63v-5.9c0-2.55-2.09-4.63-4.63-4.63h0Z"/>
  <path class="cls-1" d="m63.52,15.73h-2.26v13.35c0,.58-.48,1.06-1.06,1.06h-1.29c-.59,0-1.06-.48-1.06-1.06v-13.35h-2.26c-.96,0-1.56-1.04-1.08-1.87l3.96-6.86c.49-.83,1.68-.83,2.16,0l3.96,6.86c.49.83-.12,1.87-1.07,1.87Z"/>
</svg>
</template>

<script>
export default {
    name: "DashboardExportIcon",
}
</script>


<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #187382;
  }
  .cls-3 {
    fill: #b6dfce;
  }
  .cls-4 {
    fill: #65c8c9;
  }
</style>